export const TEST_STEP_CONDITION_TYPE = {
  CONDITION_IF: "CONDITION_IF",
  CONDITION_ELSE_IF: "CONDITION_ELSE_IF",
  CONDITION_ELSE: "CONDITION_ELSE",
  LOOP_FOR: "LOOP_FOR",
  LOOP_WHILE: "LOOP_WHILE",
  NOT_USED: "NOT_USED",
  FOR_LOOP: "FOR_LOOP",
};
